export default __webpack_public_path__ + "assets/e872622d26f1f28382cdb0d1855d1e17.svg";